/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    disabled: false,
    componentClass: 'a',
};

const TooltipItem = (props) => {
    const classNames = [
        'c-tooltip__item',
        props.disabled ? 'c-tooltip__item_disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TooltipItem.propTypes = propTypes;

TooltipItem.defaultProps = defaultProps;

export default TooltipItem;
